// Frontend deploy бүр дээр энэ утгыг солино.
export const FRONTEND_VERSION = "2026.10.08.1";
